import { COR_LIST_WITHOUT_BLACK_LIST } from 'constants/countryOfResidence'

export const FILTER_KEYS: Record<string, string> = {
  applicationIds: 'Id',
  companies: 'companyName',
  countries: 'countries',
  submissionDates: 'submissiondate',
  emails: 'email',
  processDate: 'processDate',
  reviewers: 'reviewers',
}

export const COR_MAP = new Map(
  COR_LIST_WITHOUT_BLACK_LIST.map((item) => [item.code, item.name])
)
export const REVERSE_COR_MAP = new Map(
  COR_LIST_WITHOUT_BLACK_LIST.map((item) => [item.name, item.code])
)
